import React from 'react';

import reserving from '~/common/images/reserving.png';
import loader from '~/common/images/dot-loader-icon.svg';

import styles from './loadingSpinner.css';

const LoadingSpinner = (props) => {
    const { className, showDotLoader } = props;
    return (
        <img
            alt="Loading Request"
            className={`${styles.loading} ${className || ''}`}
            src={showDotLoader ? loader : reserving}
            title="Loading Request"
        />
    );
};

export default LoadingSpinner;
